"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _FormBase = _interopRequireDefault(require("@components/Form/FormBase"));

var _stylesModule = _interopRequireDefault(require("@components/Form/FormBase/styles.module.scss"));

var _scss = require("@scss");

var _excluded = ["name", "label", "checked", "defaultChecked", "error", "disabled", "id", "isRadio", "isSwitch", "className", "classes"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Checkbox = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      label = _ref.label,
      checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      error = _ref.error,
      disabled = _ref.disabled,
      id = _ref.id,
      isRadio = _ref.isRadio,
      isSwitch = _ref.isSwitch,
      className = _ref.className,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {
    element: '',
    wrapper: '',
    label: '',
    validator: ''
  } : _ref$classes,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_FormBase["default"], {
    classes: {
      wrapper: (0, _scss.cls)(classes['wrapper'], _stylesModule["default"]['custom-control'], isRadio && _stylesModule["default"]['custom-radio'], isSwitch && _stylesModule["default"]['custom-switch'], !isRadio && !isSwitch && _stylesModule["default"]['custom-checkbox'], className),
      validator: (0, _scss.cls)(classes['validator'])
    },
    error: error
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    ref: ref,
    type: isRadio ? 'radio' : 'checkbox',
    className: (0, _scss.cls)(_stylesModule["default"]['custom-control-input'], classes['element'], error && 'is-invalid'),
    id: isRadio ? id : name,
    name: name
  }, disabled && {
    disabled: disabled
  }, checked && {
    checked: true
  }, defaultChecked && {
    defaultChecked: true
  }, props)), /*#__PURE__*/_react["default"].createElement("label", {
    className: (0, _scss.cls)(_stylesModule["default"]['custom-control-label'], classes['label']),
    htmlFor: isRadio ? id : name,
    dangerouslySetInnerHTML: {
      __html: label
    }
  }));
});
var _default = Checkbox;
exports["default"] = _default;